var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('img',{attrs:{"src":require("@/assets/imgs/emptyState.svg"),"alt":""}}),_c('h4',{staticClass:"c-ndarkfour bold"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"c-ndarkfour"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }